// ============================================
// Manor Miser - Client Entry Point
// ============================================

import Phaser from 'phaser';
import { BootScene } from './scenes/BootScene';
import { MenuScene } from './scenes/MenuScene';
import { LobbyScene } from './scenes/LobbyScene';
import { GameScene } from './scenes/GameScene';
import { ResultsScene } from './scenes/ResultsScene';
import { SoundManager } from './audio/SoundManager';
import { getOrientation, getCanvasSize } from './layout/LayoutConstants';

// Detect initial orientation and canvas size
let currentOrientation = getOrientation();
const initialSize = getCanvasSize(currentOrientation);

const config: Phaser.Types.Core.GameConfig = {
  type: Phaser.AUTO,
  parent: 'game-container',
  backgroundColor: '#1a1412',
  scale: {
    mode: Phaser.Scale.FIT,
    autoCenter: Phaser.Scale.CENTER_BOTH,
    width: initialSize.width,
    height: initialSize.height,
  },
  render: {
    pixelArt: true,
    antialias: false,
    roundPixels: true,
    powerPreference: 'high-performance',
  },
  audio: {
    disableWebAudio: true,
  },
  scene: [BootScene, MenuScene, LobbyScene, GameScene, ResultsScene],
};

const game = new Phaser.Game(config);

// Orientation change listener — resize canvas and restart active scene
window.addEventListener('resize', () => {
  const newOrientation = getOrientation();
  if (newOrientation !== currentOrientation) {
    currentOrientation = newOrientation;
    const { width, height } = getCanvasSize(newOrientation);
    game.scale.setGameSize(width, height);
    // Restart the active scene so it re-lays out for the new orientation
    const activeScene = game.scene.getScenes(true)[0];
    if (activeScene) {
      activeScene.scene.restart({ orientationRestart: true });
    }
  }
});

// Initialize audio on first user interaction (required by browser autoplay policy)
const initAudioOnInteraction = () => {
  SoundManager.init();
  document.removeEventListener('click', initAudioOnInteraction);
  document.removeEventListener('keydown', initAudioOnInteraction);
};
document.addEventListener('click', initAudioOnInteraction, { once: true });
document.addEventListener('keydown', initAudioOnInteraction, { once: true });

// Hide loading screen when game is ready
game.events.once('ready', () => {
  const loading = document.getElementById('loading');
  if (loading) {
    loading.classList.add('hidden');
    setTimeout(() => loading.remove(), 500);
  }
});

console.log(`Manor Miser Client — Phaser ${Phaser.VERSION}`);
